export default __webpack_public_path__ + "static/media/08-bedrijf.ff91b2dc.png";